import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { verifySmsCode } from '../services/authService';
import '../styles/VerifySms.css';

interface LocationState {
  phoneNumber: string;
  token: string;
  kimlikno: string;
}

interface VerifySmsProps {
  setIsAuthenticated: (value: boolean) => void;
}

const VerifySms: React.FC<VerifySmsProps> = ({ setIsAuthenticated }) => {
  const [smsCode, setSmsCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [timeLeft, setTimeLeft] = useState(120); // 2 dakika
  
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  
  useEffect(() => {
    // Token yoksa login sayfasına yönlendir
    if (!state || !state.token) {
      console.log('Token bulunamadı, login sayfasına yönlendiriliyor...');
      navigate('/login');
      return;
    }
    
    // Zaman sayacı
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [navigate, state]);
  
  const handleVerify = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await verifySmsCode(state.kimlikno, state.phoneNumber, smsCode);
      
      if (response.success && response.data) {
        // Kullanıcı bilgilerini sessionStorage'a kaydet
        const userInfo = {
          uyeId: response.data.user.uyeid,
          uyeNo: response.data.user.uyeno,
          kimlikNo: response.data.user.kimlikno,
          grup: response.data.user.grubu,
          durum: response.data.user.durumu
        };
        
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        sessionStorage.setItem('token', response.data.token);
        
        // Oturumu aç
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
        
        // Ana sayfaya yönlendir
        navigate('/');
      } else {
        setError(response.message || 'SMS doğrulama başarısız.');
      }
    } catch (err: any) {
      setError(err.message || 'SMS doğrulama sırasında bir hata oluştu.');
      console.error('SMS doğrulama hatası:', err);
    } finally {
      setLoading(false);
    }
  };
  
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };
  
  return (
    <div className="sms-verify-container">
      <div className="sms-verify-card">
        <img 
          src="/images/logo2024.png" 
          alt="İstanbul Havalimanı Taksi Kooperatifi" 
          className="logo"
        />
        <h3>SMS Doğrulama</h3>
        
        <p>
          {state?.phoneNumber ? `${state.phoneNumber.substring(0, 4)}******${state.phoneNumber.substring(state.phoneNumber.length - 2)}` : ''}
          numaralı telefonunuza gönderilen 6 haneli doğrulama kodunu girin.
        </p>
        
        <div className="timer">Kalan süre: {formatTime(timeLeft)}</div>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleVerify}>
          <div className="form-group">
            <input
              type="text"
              value={smsCode}
              onChange={(e) => setSmsCode(e.target.value.replace(/[^0-9]/g, '').substring(0, 6))}
              maxLength={6}
              placeholder="SMS Kodu"
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="verify-button"
            disabled={loading || timeLeft === 0}
          >
            {loading ? 'Doğrulanıyor...' : 'Doğrula'}
          </button>
          
          <button 
            type="button" 
            className="back-button"
            onClick={() => navigate('/login')}
          >
            Geri Dön
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifySms; 